import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  inject,
} from '@angular/core';
import { ButtonComponent } from '@freelancer/ui/button';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { QueryParams } from '@freelancer/ui/link';

type SplitButtonPrimaryDisplay = 'inline' | 'block';

@Component({
  standalone: true,
  selector: 'fl-split-button-primary',
  imports: [ButtonComponent],
  template: `
    <fl-button
      class="PrimaryButton"
      [color]="color"
      [display]="display"
      [displayTablet]="displayTablet"
      [displayDesktop]="displayDesktop"
      [link]="link"
      [newTab]="newTab"
      [queryParams]="linkQueryParams"
      [size]="size"
      [sizeTablet]="sizeTablet"
      [sizeDesktop]="sizeDesktop"
      [busy]="busy"
      [buttonGroupFirst]="buttonGroupFirst && !busy"
    >
      <ng-content></ng-content>
    </fl-button>
  `,
  styleUrls: ['./split-button-primary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplitButtonPrimaryComponent {
  changeDetectorRef = inject(ChangeDetectorRef);

  @Input() link?: string;
  @Input() linkQueryParams?: QueryParams;
  @Input() buttonGroupFirst: boolean;

  @Input() busy: boolean;
  @Input() newTab?: boolean = false;
  @Input() size: ButtonSize;
  @Input() sizeTablet?: ButtonSize;
  @Input() sizeDesktop?: ButtonSize;
  @Input() color: ButtonColor;

  @HostBinding('attr.data-display')
  @Input()
  display: SplitButtonPrimaryDisplay = 'inline';
  @HostBinding('attr.data-display-tablet')
  @Input()
  displayTablet?: SplitButtonPrimaryDisplay;
  @HostBinding('attr.data-display-desktop')
  @Input()
  displayDesktop?: SplitButtonPrimaryDisplay;
}
